import React from 'react';
import { Box, InfoIcon } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

const MyChoiceDisclaimerTitle = () => {
  const { t } = useTranslation();
  const { sizeExtraLarge, fontSemiBold, primaryFrontColor } = useTheme();

  return (
    <Box
      p={2}
      color={primaryFrontColor}
      fontSize={sizeExtraLarge}
      fontWeight={fontSemiBold}
      alignItems={'center'}
      display={'flex'}
      gap={1}
      width={'100%'}
    >
      <InfoIcon color={primaryFrontColor} />
      {t('containers.benefit_groups.my_choice_disclaimer.title')}
    </Box>
  );
};

export { MyChoiceDisclaimerTitle };
